import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import "./index.css";
import { AdminLoginPage } from "./AdminLoginPage";
import { AdminListenerListPage } from "./AdminListenerListPage";
import { AdminStreamListPage } from "./AdminStreamListPage";
import { AdminStreamingStatsPage } from "./AdminStreamingStatsPage";
import { AuthGate } from "./AuthGate";
import { EvolutionKitGate } from "./EvolutionKitGate";
import { LoginPage } from "./LoginPage";
import { MiniDocPage } from "./MiniDocPage";
import { MusicPlayer } from "./MusicPlayer";
import { PwaInstallProvider, usePwaInstall } from "./AppContext";
import { VerifyPage } from "./VerifyPage";

/** Registers `beforeinstallprompt` and forwards to context (must render under `PwaInstallProvider`). */
function BeforeInstallPromptSubscriber() {
  const { captureInstallPrompt } = usePwaInstall();
  useEffect(() => {
    const onBeforeInstallPrompt = (e: Event) => {
      captureInstallPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstallPrompt);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstallPrompt);
    };
  }, [captureInstallPrompt]);
  return null;
}

export function App() {
  return (
    <PwaInstallProvider>
      <BeforeInstallPromptSubscriber />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminStreamingStatsPage />} />
        <Route path="/admin/streams" element={<AdminStreamListPage />} />
        <Route path="/admin/listeners" element={<AdminListenerListPage />} />
        <Route path="/verify" element={<VerifyPage />} />
        <Route
          path="/mini-doc"
          element={
            <AuthGate>
              <EvolutionKitGate>
                <MiniDocPage />
              </EvolutionKitGate>
            </AuthGate>
          }
        />
        <Route
          path="/"
          element={
            <AuthGate>
              <MusicPlayer />
            </AuthGate>
          }
        />
      </Routes>
    </PwaInstallProvider>
  );
}

export default App;
